import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { db } from "../common/firebase.utils"
import { isInViewPort } from "../common/utils"
import CountUp from "react-countup"

function Counter() {
  const counterRef = useRef()
  const [stats, setStats] = useState()
  const [isVisible, setIsVisible] = useState(!isInViewPort(counterRef.current))

  useEffect(() => {
    const getStats = () => {
      db.collection("statistics")
        .where("__name__", "in", ["actions", "templates"])
        .get()
        .then(snapshot => {
          const _stats = {}
          snapshot.docs.forEach(doc => {
            if (doc.id === "actions") {
              const { visit, copy } = doc.data()
              if (visit === 1) {
                getStats()
                return
              }
              _stats.visitor = visit
              _stats.copied = copy
            } else if (doc.id === "templates") {
              _stats.templates = doc.data().count
            }
          })
          setStats(_stats)
        })
        .catch(() => {})
    }

    setTimeout(getStats, 500)

    const checkScroll = () => {
      if (isVisible) {
        window.removeEventListener("scroll", checkScroll)
      } else if (isInViewPort(counterRef.current)) {
        setIsVisible(true)
        window.removeEventListener("scroll", checkScroll)
      }
    }
    window.addEventListener("scroll", checkScroll)
    return () => {
      window.removeEventListener("scroll", checkScroll)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const startCounter = isVisible && stats

  return (
    <Section>
      <Grid ref={counterRef}>
        <StatItem>
          <StatLabel>누적 방문 수</StatLabel>
          <StatValue>
            <CountNumber
              startCounter={startCounter}
              endNumber={stats?.visitor}
            />
            <StatUnit>회</StatUnit>
          </StatValue>
        </StatItem>

        <StatItem>
          <StatBadge>No.1</StatBadge>
          <StatLabel>상황별 템플릿</StatLabel>
          <StatValue>
            <CountNumber
              startCounter={startCounter}
              endNumber={stats?.templates}
            />
            <StatUnit>개</StatUnit>
          </StatValue>
        </StatItem>

        <StatItem>
          <StatLabel>템플릿 복사</StatLabel>
          <StatValue>
            <CountNumber
              startCounter={startCounter}
              endNumber={stats?.copied}
            />
            <StatUnit>회</StatUnit>
          </StatValue>
        </StatItem>
      </Grid>
    </Section>
  )
}

function CountNumber({ startCounter, endNumber }) {
  return (
    <span>
      {startCounter && endNumber && (
        <CountUp
          start={0}
          end={endNumber}
          duration={1}
          formattingFn={n => Number(n).toLocaleString()}
        />
      )}
    </span>
  )
}

const Section = styled.div`
  padding: 48px 24px;
  text-align: center;

  @media (max-width: 480px) {
    padding: 24px 16px;
  }
`

const Grid = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  max-width: 720px;
  margin: 0 auto;

  @media (max-width: 480px) {
    gap: 8px;
  }
`

const StatItem = styled.div`
  position: relative;
  overflow: visible;
  flex: 1;
  text-align: center;
  padding: 20px;
  background: linear-gradient(
    165deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0.4) 100%
  );
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03),
    0 1px 0 rgba(255, 255, 255, 0.8) inset;

  @media (max-width: 480px) {
    padding: 12px;
    border-radius: 14px;
  }
`

const StatBadge = styled.span`
  position: absolute;
  top: -9px;
  left: 12px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #5551ff 0%, #5551ff 100%);
  padding: 4px 10px;
  border-radius: 100px;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 6px rgba(85, 81, 255, 0.25);
  z-index: 1;

  @media (max-width: 480px) {
    font-size: 9px;
    padding: 3px 8px;
    top: -8px;
  }
`

const StatLabel = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`

const StatValue = styled.div`
  white-space: nowrap;

  > span:first-child {
    font-family: "Space Grotesk", sans-serif;
    font-size: 32px;
    font-weight: 700;
    line-height: 1;
    color: #0f0e2c;
  }

  @media (max-width: 480px) {
    > span:first-child {
      font-size: 18px;
    }
  }
`

const StatUnit = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #6b7280;
  margin-left: 2px;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`

export default Counter
